// Auto-generated lightweight class for ThinkingPart
// DO NOT EDIT - Changes will be overwritten

import { NeoNodeBase } from '@sourcepilot/framework/neo-node-base';
import { RelationshipManager } from '@sourcepilot/framework/relationship-manager';
import { Relationship } from '@sourcepilot/framework/relationship';
import { ThinkingPartReadAPI, ThinkingPartWriteAPI, ThinkingPartReadAPISchema, ThinkingPartWriteAPISchema } from '../types/thinkingpart';
import { ModelRegistry } from '../../registries/model-registry';
import { AtScope, IsPart } from '../../relationships/relationship';

import { SecurityScope } from '../../shared/api/securityscope';
import { ModelResponse } from './modelresponse';



export interface ThinkingPart extends Partial<ThinkingPartReadAPI> {}
export class ThinkingPart extends NeoNodeBase<ThinkingPartReadAPI, ThinkingPartWriteAPI> {
  // Static label for identifying this model type (minification-safe)
  static readonly label = "ThinkingPart";
  static readonly readSchema = ThinkingPartReadAPISchema;
  static readonly writeSchema = ThinkingPartWriteAPISchema;

  // Per-relationship metadata, keyed by property name on this class.
  // See `framework/data/dag-sync/reverse-property.ts` for how the DAG
  // client uses (relClass, direction) to route patches back to the
  // correct property — especially for polymorphic-source rels.
  static readonly relationships: Record<string, {
    target: string;
    cardinality: 'one' | 'many';
    isParent: boolean;
    relClass: string;
    direction: 'in' | 'out';
  }> = {
    model_response: { target: "ModelResponse", cardinality: "one", isParent: true, relClass: "IsPart", direction: "in" },
  };

  protected get modelName(): string {
    return 'ThinkingPart';
  }

  // Instance getter for label (used in DAG sync and type identification)
  get _label(): string {
    return ThinkingPart.label;
  }


  constructor(data: Partial<ThinkingPartWriteAPI> = {}) {
    super(data);
  }

/**
   * Load instance from server data with Zod validation
   * Recursively instantiates nested relationship objects
   *
   * @param data - Node data from API (ReadAPI format)
   * @param loadContext - Optional LoadContext from backend QueryResult for eager-loaded relationships
   * @returns Class instance with nested relationships instantiated
   */
  static load(data: ThinkingPartReadAPI, loadContext?: Record<string, any>): ThinkingPart {
    // Import relationship loaders
    const { loadOneRelationship, loadManyRelationship } = require('@sourcepilot/framework/load-relationship');

    // Strip relationship fields before validation (they'll be processed separately)
    const { security_scope, model_response, _label, ...dataToValidate } = data as any;

    // Validate with Zod schema (only non-relationship fields)
    const validated = ThinkingPartReadAPISchema.parse(dataToValidate);

    // Re-add relationship fields to validated data for processing
    const dataWithRelationships: any = { ...validated, security_scope: security_scope, model_response: model_response };

    // If loadContext provided, use NeoGraphParser to reconstruct relationships
    if (loadContext && validated.id) {
      // Import NeoGraphParser dynamically to avoid circular dependencies
      const { NeoGraphParser } = require('@sourcepilot/framework/neograph-utils');
      const parser = new NeoGraphParser();
      const graphNodes = parser.parse([validated], loadContext);

      if (graphNodes.length > 0) {
        // Convert graph structure back to plain object with relationships
        const withRelationships = parser.toPlainObject(graphNodes[0]);
        // Recursively instantiate via ModelRegistry (without loadContext to avoid infinite loop)
        return ThinkingPart.load(withRelationships);
      }
    }

    // Recursively instantiate nested relationships from inline data
    const processed: any = { ...dataWithRelationships };

    // Process relationships: convert to class instances and store with private property names
    loadOneRelationship(processed, 'security_scope', 'SecurityScope', ModelRegistry);
    loadOneRelationship(processed, 'model_response', 'ModelResponse', ModelRegistry);
    // Create instance with processed data (constructor uses Object.assign)
    // Private properties (_*) won't conflict with relationship getters
    const instance = new ThinkingPart(processed as any);

    return instance;
  }


  // Relationship manager for 'security_scope' - Python ORM style (cached)
  get security_scope(): RelationshipManager<this, SecurityScope> {
    return this.getOrCreateRelationshipManager('security_scope', () => {
      return new RelationshipManager(this, 'security_scope', 'one', AtScope as typeof Relationship);
    });
  }

  // Relationship manager for 'model_response' - Python ORM style (cached)
  get model_response(): RelationshipManager<this, ModelResponse> {
    return this.getOrCreateRelationshipManager('model_response', () => {
      return new RelationshipManager(this, 'model_response', 'one', IsPart as typeof Relationship);
    });
  }

}
